module.exports = __webpack_public_path__ + "static/img/img-3.013ba42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-3.jpg
// module id = o54c
// module chunks = 0